import { useTranslation } from "react-i18next";
import { IBreadcrumbsAndMenu } from "types/global";
import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { useStateContext } from "contexts/auth-context";
import { Navigate } from "react-router-dom";
import CustomizedBreadcrumbs from "components/Custom/CustomizedBreadcrumbs";
import HeaderLayout from "components/UI/HeaderLayout";
import { Box, Typography } from "@mui/material";
import CustomizedButton from "components/Custom/CustomizedButton";
import { usePurchaseReport } from "hooks/Purchase/PurchaseReport/use-purchase-report";
import { PurchaseExportType } from "generated/purchase";
import { PurchaseByProductTable } from "components/Table/Purchase/Report/PurchaseByProductTable";
import { useElementHeight } from "hooks/use-element-height";

const PurchaseByProduct = () => {
  const { t } = useTranslation();
  const {
    state: { permissions },
  } = useStateContext();
  const [headerRef, headerHeight] = useElementHeight();

  const gridRef = useRef<AgGridReact>(null);

  const { onBtnExport, isLoading } = usePurchaseReport(
    gridRef,
    PurchaseExportType.PurchaseOrderByProduct
  );

  const breadcrumbs: IBreadcrumbsAndMenu[] = [
    {
      name: t("purchase.index"),
      to: "/purchase",
    },
    {
      name: t("report"),
      to: "/purchase/report",
    },
    {
      name: t("purchase.report.purchase_by_product"),
    },
  ];

  if (permissions && !permissions.purchase_export?.view) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <>
      <Box ref={headerRef}>
        <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
        <HeaderLayout noMaxWidth={true}>
          <Typography variant="h5">
            {t("purchase.report.purchase_by_product")}
          </Typography>
          {permissions?.purchase_export?.export && (
            <CustomizedButton
              title={`${t("button.export")}`}
              variant="contained"
              onClick={onBtnExport}
              disabled={isLoading}
            />
          )}
        </HeaderLayout>
      </Box>
      <PurchaseByProductTable gridRef={gridRef} height={`calc(90vh - ${headerHeight + 85}px)`} />
    </>
  );
};

export default PurchaseByProduct;
